/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/no-unused-state */
/* eslint-disable no-undef */
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { get, includes } from "lodash";
import { List, ListItem, ListItemText, Box } from "@material-ui/core";
import {
  CalendarToday,
  Bookmark,
  Stars,
  Group,
  SettingsOutlined,
  CreditCard,
  MessageOutlined,
  StarsOutlined,
  Settings,
  BookmarkBorderOutlined,
  Add,
} from "@material-ui/icons";
import { ReactComponent as CollapseIcon } from "../../../Assets/Images/collapse_icon.svg";
import { ReactComponent as ExpandIcon } from "../../../Assets/Images/expand_icon.svg";
import { ReactComponent as Exit } from "../../../Assets/Images/logout.svg";
import userAvatarPlaceholder from "../../../Assets/Images/User_avatar.png";
import { withStyles } from "@material-ui/core/styles";
import { loadClient } from "../../../Actions";
import { ACCEPT_LANGUAGE_HEADER, HOST_ROOT } from "../../../apiConfig";
import "./Assets/Styles/AccountSidebar.scss";
import CTAButton from "../../Shared/CTAButton";
import Drawer from "@material-ui/core/Drawer";
import { logoutEvent } from "../WebAnalytics";
import axios from "axios";
import { isUnclosableNavRoute } from "../../../constants";

const SIDEBAR_WIDTH = "15vw";
const SIDEBAR_MIN_WIDTH = "15vw"; // Minimum width for larger screens
const SIDEBAR_MAX_WIDTH = "17vw";

const STICKY_ROUTES = [
  "appointments",
  "inbox",
  "soothe-pass",
  "appointment_management",
  "sign_on",
];

function isStickySidebarRoute(pathname) {
  return STICKY_ROUTES.some((route) => pathname.includes(route));
}

const useStyles = (theme) => ({
  sidebar: {
    position: "fixed",
    top: 0,
    left: 0,
    marginTop: "80px", // Push drawer below header
    height: "100vh", // Adjust height to account for header
    // width: SIDEBAR_WIDTH,
    paddingTop: theme.spacing(2),
    minWidth: SIDEBAR_MIN_WIDTH,
    maxWidth: SIDEBAR_MAX_WIDTH,
    backgroundColor: "#FFFFFF",
    borderRight: "1px solid #E2E2E2",
    zIndex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    transition: "width 0.1s ease-out",
    transform: "translateZ(0)",
    willChange: "transform",
    WebkitOverflowScrolling: "touch",
    backfaceVisibility: "hidden",
    [theme.breakpoints.down("md")]: {
      // width: 40,
      minWidth: 42,
      maxWidth: "fit-content",
      marginTop: 0,
      paddingTop: "12px",
    },
    [theme.breakpoints.down("sm")]: {
      minWidth: 42,
      maxWidth: "fit-content",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      transition: "width 0.1s ease-out",
      marginTop: "80px", // Push drawer below header
      height: "100vh", // Adjust height to account for header
      // width: SIDEBAR_WIDTH,
      paddingTop: theme.spacing(2),
    },
  },
  menuList: {
    padding: theme.spacing(0),
    backgroundColor: "#FFFFFF",
    flex: 1,
  },
  menuItem: {
    padding: "12px 24px!important",
    margin: "0px!important",
    transition: "background-color 0.1s ease, border-right 0.1s ease",
    "&:hover:not(.active)": {
      backgroundColor: "#F8F9FA",
    },
    "&.active": {
      backgroundColor: "#F1F7FF",
      borderRight: "4px solid #586B94",
      "& .MuiListItemIcon-root": {
        color: "#586B94!important",
      },
      "& .MuiListItemText-primary": {
        color: "#586B94!important",
        fontWeight: 400,
      },
      "& .MuiSvgIcon-root": {
        color: "#586B94!important",
      },
    },
    // Add override for needs-attention + active
    "&.needs-attention": {
      backgroundColor: "#FFEFED !important",
    },
    "&.needs-attention.active": {
      backgroundColor: "#FFEFED !important",
      borderRight: "4px solid #C11500",
      "& .MuiListItemIcon-root": {
        color: "#C11500!important",
      },
      "& .MuiListItemText-primary": {
        color: "#C11500!important",
        fontWeight: 400,
      },
      "& .MuiListItemText-secondary": {
        color: "#C11500!important",
        fontSize: "12px",
        fontWeight: 500,
      },
      "& .MuiSvgIcon-root": {
        color: "#C11500!important",
      },
    },
    "& .MuiListItemText-root": {
      margin: "0!important",
    },
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
      padding: "12px!important",
    },
  },
  menuIcon: {
    width: 24,
    height: 24,
    color: "#757575!important",
    transition: "color 0.2s ease",
    paddingRight: "8px!important",
    [theme.breakpoints.down("md")]: {
      paddingRight: "0!important",
      margin: "0 auto",
      display: "block",
      width: "16px!important",
      height: "16px!important",
    },
    [theme.breakpoints.down("sm")]: {
      paddingRight: "8px!important",
      margin: "0 auto",
      display: "block",
      width: "24px!important",
      height: "24px!important",
    },
  },
  collapseIcon: {
    width: 24,
    height: 24,
    color: "#ADB4D2!important",
    transition: "color 0.2s ease",
    paddingRight: "8px!important",
    [theme.breakpoints.down("sm")]: {
      paddingRight: "0!important",
      margin: "0 auto",
      display: "block",
      width: "16px!important",
      height: "16px!important",
    },
  },
  menuText: {
    fontFamily: "Poppins",
    fontSize: "16px!important",
    lineHeight: "24px!important",
    fontWeight: "400!important",
    color: "#757575!important",
    transition: "color 0.2s ease",
    margin: "0!important",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
    [theme.breakpoints.down("sm")]: {
      display: "inline",
    },
  },
  menuTextNeedsAttention: {
    fontFamily: "Poppins",
    fontSize: "16px!important",
    lineHeight: "24px!important",
    fontWeight: "400!important",
    color: "#C11500!important",
    transition: "color 0.2s ease",
    margin: "0!important",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  ctaBox: {
    width: "100%",
    backgroundColor: "#FFFFFF",
    padding: "16px 0",
    borderTop: "1px solid #E2E2E2",
    position: "sticky",
    bottom: 0,
    left: 0,
  },
  hamburger: {
    position: "fixed",
    // transform: 'translateZ(0)',
    top: 90,
    left: 16,
    zIndex: 2000,
    background: "#fff",
    borderRadius: "50%",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    width: 40,
    height: 40,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    [theme.breakpoints.down("md")]: {
      top: 12,
      left: 12,
      padding: "12px",
    },
  },
});

class AccountSidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openAccountInfo: false,
      openPMethods: false,
      openABook: false,
      drawerOpen: false,
      bookNowClicked: false,
    };
  }
  componentDidUpdate(prevProps) {
    const { open } = this.props;
    if (open && !prevProps.open) {
      this.setState({ drawerOpen: true, bookNowClicked: false });
    }
    // else if (!open && prevProps.open) {
    //   this.setState({ drawerOpen: false });
    // }
  }

  isActiveRoute = (routeType) => {
    const currentPath = window.location.pathname;

    switch (routeType) {
      case "bookings":
        return includes(currentPath, "/appointments");
      case "inbox":
        return includes(currentPath, "/inbox");
      case "paymentMethods":
        return includes(currentPath, "/account/payment-methods");
      case "addressBook":
        return includes(currentPath, "/account/address-book");
      case "soothe-pass":
        return includes(currentPath, "/account/soothe-pass");
      case "invite-friends":
        return includes(currentPath, "/account/invite-friends");
      case "settings":
        return includes(currentPath, "/account/settings");
      case "bookNow":
        return includes(currentPath, "/booking");
      default:
        return false;
    }
  };

  handleMenuClick = (menuType) => {
    switch (menuType) {
      case "inbox":
        window.location.href = `${HOST_ROOT}/inbox/`;
        break;
      case "bookings":
        window.location.href = `${HOST_ROOT}/appointments/`;
        break;
      case "paymentMethods":
        window.location.href = `${HOST_ROOT}/account/payment-methods/`;
        break;
      case "addressBook":
        window.location.href = `${HOST_ROOT}/account/address-book/`;
        break;
      case "soothe-pass":
        window.location.href = `${HOST_ROOT}/account/soothe-pass/`;
        break;
      case "invite-friends":
        window.location.href = `${HOST_ROOT}/account/invite-friends/`;
        break;
      case "settings":
        window.location.href = `${HOST_ROOT}/account/settings/`;
        break;
      case "bookNow":
        // Immediately hide button and close sidebar for better UX
        this.setState({ bookNowClicked: true, drawerOpen: false });
        // Also notify parent component
        if (this.props.onClose) {
          this.props.onClose();
        }

        // Only navigate if not already on booking page
        const currentPath = window.location.pathname;
        if (!includes(currentPath, "/booking")) {
          window.location.href = `${HOST_ROOT}/booking/`;
        } else {
          // Reset button state after animation if staying on same page
          // setTimeout(() => {
          this.setState({ bookNowClicked: false });
          // }, 150);
        }
        return;
      default:
        break;
    }
    // Close drawer if not sticky
    if (!isUnclosableNavRoute(window.location.pathname)) {
      this.setState({ drawerOpen: false });
    }
  };

  handleDrawerOpen = () => {
    this.setState({ drawerOpen: true, bookNowClicked: false });
  };

  handleDrawerClose = () => {
    this.props.onClose();
    this.setState({ drawerOpen: false });
  };

  renderSidebarContent = () => {
    const { classes, width } = this.props;
    const loggedIn = get(this.props, "client.loggedIn", false);
    const needsAttention = get(
      this.props,
      "client.soothe_pass.needs_attention",
      false
    );

    return (
      <Box className={classes.sidebar} style={{ boxShadow: "none" }}>
        <List className={classes.menuList}>
          {/* {width < 800 
          // && !isUnclosableNavRoute(window.location.pathname) 
          ? <ListItem
            button
            title="Close Sidebar"
            className={`${classes.menuItem}`}
            onClick={() => this.handleDrawerClose()}
          >
            <CollapseIcon className={classes.collapseIcon} />
          </ListItem> : null} */}
          {/* {loggedIn && width < 1000 ?
            <ListItem className={`${classes.menuItem}`}>
              <img
                // className="w-h-20 br-rd-50 br-opaque"
                className={classes.menuIcon}
                src={get(this.props, 'client.avatar_url', userAvatarPlaceholder) || userAvatarPlaceholder} alt="User avatar" />
            </ListItem>
            : null} */}
          <ListItem
            button
            title="Bookings"
            className={`${classes.menuItem} ${
              this.isActiveRoute("bookings") ? "active" : ""
            }`}
            onClick={() => this.handleMenuClick("bookings")}
          >
            <CalendarToday className={classes.menuIcon} />
            <ListItemText
              primary="Bookings"
              classes={{ primary: classes.menuText }}
            />
          </ListItem>
          <ListItem
            button
            title="Inbox"
            className={`${classes.menuItem} ${
              this.isActiveRoute("inbox") ? "active" : ""
            }`}
            onClick={() => this.handleMenuClick("inbox")}
          >
            <MessageOutlined className={classes.menuIcon} />
            <ListItemText
              primary="Inbox"
              classes={{ primary: classes.menuText }}
            />
          </ListItem>
          <ListItem
            button
            className={`${classes.menuItem} ${
              this.isActiveRoute("paymentMethods") ? "active" : ""
            }`}
            onClick={() => this.handleMenuClick("paymentMethods")}
          >
            <CreditCard className={classes.menuIcon} />
            <ListItemText
              primary="Payment Methods"
              classes={{ primary: classes.menuText }}
            />
          </ListItem>
          <ListItem
            button
            className={`${classes.menuItem} ${
              this.isActiveRoute("addressBook") ? "active" : ""
            }`}
            onClick={() => this.handleMenuClick("addressBook")}
          >
            {this.isActiveRoute("addressBook") ? (
              <Bookmark className={classes.menuIcon} />
            ) : (
              <BookmarkBorderOutlined className={classes.menuIcon} />
            )}
            <ListItemText
              primary="Address Book"
              classes={{ primary: classes.menuText }}
            />
          </ListItem>
          <ListItem
            button
            title="SoothePass"
            className={`${classes.menuItem} ${
              this.isActiveRoute("soothe-pass") ? "active" : ""
            } ${needsAttention ? "needs-attention" : ""}`}
            onClick={() => this.handleMenuClick("soothe-pass")}
            style={{
              borderRight:
                needsAttention && this.isActiveRoute("soothe-pass")
                  ? "4px solid #C11500"
                  : undefined,
            }}
          >
            {needsAttention ? (
              <span style={{ display: "flex", alignItems: "center" }}>
                <span
                  style={{
                    color: "#C11500",
                    marginRight: 8,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M1 21H23L12 2L1 21Z" fill="#C11500" />
                    <path
                      d="M13 16H11V18H13V16ZM13 10H11V14H13V10Z"
                      fill="white"
                    />
                  </svg>
                </span>
                <ListItemText
                  primary={<span>SoothePass</span>}
                  secondary={
                    <span style={{ color: "#C11500", fontSize: 12 }}>
                      Needs Attention
                    </span>
                  }
                  classes={{
                    primary: classes.menuTextNeedsAttention,
                    secondary: "MuiListItemText-secondary",
                  }}
                />
              </span>
            ) : (
              <>
                {this.isActiveRoute("soothe-pass") ? (
                  <Stars className={classes.menuIcon} />
                ) : (
                  <StarsOutlined className={classes.menuIcon} />
                )}
                <ListItemText
                  primary="SoothePass"
                  classes={{ primary: classes.menuText }}
                />
              </>
            )}
          </ListItem>
          <ListItem
            button
            className={`${classes.menuItem} ${
              this.isActiveRoute("invite-friends") ? "active" : ""
            }`}
            onClick={() => this.handleMenuClick("invite-friends")}
          >
            <Group className={classes.menuIcon} />
            <ListItemText
              primary="Invite Friends"
              classes={{ primary: classes.menuText }}
            />
          </ListItem>
          <ListItem
            button
            className={`${classes.menuItem} ${
              this.isActiveRoute("settings") ? "active" : ""
            }`}
            onClick={() => this.handleMenuClick("settings")}
          >
            {this.isActiveRoute("settings") ? (
              <Settings className={classes.menuIcon} />
            ) : (
              <SettingsOutlined className={classes.menuIcon} />
            )}
            <ListItemText
              primary="Settings"
              classes={{ primary: classes.menuText }}
            />
          </ListItem>
          {/* {loggedIn && width < 1000 ? <ListItem
            button
            title="Logout"
            className={`${classes.menuItem}`}
            onClick={() => {
              logoutEvent();
              axios.delete(
                `${HOST_ROOT}/users/sign_out`,
                { withCredentials: true },
                ACCEPT_LANGUAGE_HEADER,
              ).then(() => {
                this.props.loadClient({ loggedIn: false });
                window.location.href = `${HOST_ROOT}/sign_on/`;
              }).catch(() => {
                this.props.loadClient({ loggedIn: false });
                window.location.href = `${HOST_ROOT}/sign_on/`;
              });
            }}>
            <Exit className={classes.menuIcon} />
          </ListItem> : null} */}
        </List>
        {width < 1000 && width > 800 ? (
          <button
            className="btn contentInversePrimary bg-cactus-flower br-rd-4 m-auto"
            title="Book Now"
            style={{
              borderRadius: "4px",
              marginBottom: "12px",
              padding: "8px",
              lineHeight: "14px",
              opacity: this.state.bookNowClicked ? 0 : 1,
              transition: "opacity 0.1s ease-out",
            }}
            onClick={() => this.handleMenuClick("bookNow")}
            disabled={this.state.bookNowClicked}
          >
            <Add className="w-h-14" />
          </button>
        ) : (
          <Box
            className={classes.ctaBox}
            style={{
              opacity: this.state.bookNowClicked ? 0 : 1,
              transition: "opacity 0.1s ease-out",
            }}
          >
            <CTAButton
              text="Book Now"
              action={() => this.handleMenuClick("bookNow")}
              disabled={this.state.bookNowClicked}
              additionalWrapperClass="br-top-none-imp sm-relative-imp"
              additionalClass="md-cta-primary centered p-16-20-imp"
            />
            {/* TODO use plain button tag */}
          </Box>
        )}
      </Box>
    );
  };

  render() {
    const { classes, width } = this.props;
    const isSticky = isStickySidebarRoute(window.location.pathname);
    const loggedIn = get(this.props, "client.loggedIn", false);
    const isUnclosable = isUnclosableNavRoute(window.location.pathname);
    // Sticky mode: always visible
    if (isUnclosable && width >= 800) {
      return this.renderSidebarContent();
    }
    // Drawer mode: show hamburger, open/close sidebar
    return (
      <>
        {/* {this.state.drawerOpen || width >= 1000 || (!loggedIn && isSticky) ? null : <div className={classes.hamburger} onClick={this.handleDrawerOpen}
          title="Open Sidebar">
          <ExpandIcon className={classes.collapseIcon} />
        </div>} */}
        <Drawer
          className="drawer-wrapper"
          anchor="left"
          open={this.state.drawerOpen}
          onClose={this.handleDrawerClose}
          ModalProps={{ keepMounted: true }}
          transitionDuration={{ enter: 150, exit: 80 }}
          SlideProps={{
            style: {
              transform: "translateZ(0)",
              willChange: "transform",
            },
          }}
        >
          {this.renderSidebarContent()}
        </Drawer>
      </>
    );
  }
}

AccountSidebar.propTypes = {
  client: PropTypes.object.isRequired,
  loadClient: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  width: PropTypes.number,
  onClose: PropTypes.func,
};

const mapStateToProps = (state) => ({
  client: state.client,
});

export { isStickySidebarRoute };
export default connect(mapStateToProps, { loadClient })(
  withStyles(useStyles)(AccountSidebar)
);
